export default __webpack_public_path__ + "static/media/storyVideo.9b147ca0.svg";